<script setup>
import HTitle from "~/components/seo/HTitle.vue"
import Button from "~/components/common/Button.vue"

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const blockContent = computed(() => props.data.content)
const haveVSpacing = computed(() => blockContent.value.vSpacing)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'mb-0': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})
</script>

<template>
  <div v-if="blockContent" class="grid grid-cols-12 gap-0 bg-[#fcfbfa] mt-3" :class="containerClasses">
    <div class="col-span-12 lg:col-span-5 px-8 lg:px-12 pt-5 pb-12 flex flex-col order-2 lg:order-1 justify-center">
      <HTitle v-if="blockContent.preTitle" class="text-sm font-normal uppercase !text-[#363330]" :type="blockContent.preTitleH">{{ blockContent.preTitle }}</HTitle>
      <HTitle v-if="blockContent.title" class="text-4xl text-justify lg:text-justify lg:text-5xl my-2 !text-[#363330]" :type="blockContent.titleH">{{ blockContent.title }}</HTitle>
      <div v-html="blockContent.description" class="mb-4 lg:mb-8 text-justify !text-[#363330]">
      </div>
      <template v-if="blockContent.url">
        <Button
          class="rounded-md !p-3 text-center font-bold !text-md w-full"
          :to="blockContent.url"
          :label="blockContent.btnTitle"
          severity="primary"
        />
      </template>
    </div>
    <div class="col-span-12 lg:col-span-7 order-1 lg:order-2">
      <img :src="blockContent.image" alt="image" class="w-full">
    </div>
  </div>
</template>
